import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { AppTheme } from '../../theme-switch.interface';
import { ThemeSwitchService } from '../../theme-switch.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'tablesready-theme-switcher',
  templateUrl: './theme-switcher.component.html',
  styleUrls: ['./theme-switcher.component.scss'],
})
export class ThemeSwitcherComponent implements OnInit, OnDestroy {
  @Input() toggleId = 'toggle-id';

  isToggleChecked: boolean;

  private readonly subscription = new Subscription();

  constructor(private readonly service: ThemeSwitchService) {
    this.isToggleChecked = this.service.getSavedTheme() === AppTheme.dark;
  }

  ngOnInit(): void {
    const themeSub = this.service.themeChange$
      .subscribe((theme) => {
        this.isToggleChecked = theme === AppTheme.dark;
      });
    this.subscription.add(themeSub);
  }

  toggleTheme(): void {
    this.service.setTheme(this.isToggleChecked ? AppTheme.dark : AppTheme.light);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
